<template>
    <div>
        <div v-for="(item, index) in items" :key="index">
            <router-link
                v-if="item.isLink"
                :to="{
                    name: 'item',
                    params: {
                        id: item.encodedId
                    }
                }"
            >
                {{ item.label }}
            </router-link>
            <span v-else>{{ item.label }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        record: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            items: []
        };
    },
    mounted() {
        const record = this.record;

        switch (record.source) {
            case "ONPREM":
                if (record.item && Object.keys(record.item).length > 0) {
                    if (record.item.encoded_id) {
                        this.itemEncodedId = record.item.encoded_id;
                        this.items.push({
                            isLink: true,
                            label: record.item.name,
                            encodedId: record.item.encoded_id
                        });
                    } else {
                        this.items.push({
                            isLink: false,
                            label: record.item.name
                        });
                    }
                    return;
                } else {
                    if (record.item_name) {
                        this.items.push({
                            isLink: false,
                            label: record.item_name
                        });
                    }
                }
                break;

            case "ABAXIS_API":
            case "ABAXIS_FUSE":
                if (record.item && Object.keys(record.item).length > 0) {
                    if (record.item.encoded_id) {
                        this.items.push({
                            isLink: true,
                            label: record.item.name,
                            encodedId: record.item.encoded_id
                        });
                    } else {
                        this.items.push({
                            isLink: false,
                            label: record.item.name
                        });
                    }
                    return;
                } else {
                    if (record.item_name) {
                        this.items.push({
                            isLink: false,
                            label: record.item_name
                        });
                    }
                }
                break;

            case "IDEXX":
            case "ZNLABS":
            case "MIDWEST":
            case "NBIOVET":
            case "VETEK":
            case "MICROVET":
            case "BIONOTE":
            case "HESKA":
            case "ABAXIS":
            case "HESKA_CLOUD":
                if (record.item && Object.keys(record.item).length > 0) {
                    if (record.item.encoded_id) {
                        this.items.push({
                            label: record.item.name,
                            isLink: true,
                            encodedId: record.item.encoded_id
                        });
                    } else {
                        this.items.push({
                            isLink: false,
                            label: record.item.name
                        });
                    }
                    return;
                } else {
                    if (record.item_name) {
                        this.items.push({
                            isLink: false,
                            label: record.item_name
                        });
                    }
                }
                break;

            case "ANTECH":
                if (record.item && record.item.length > 0) {
                    this.items.push({
                        label: record.item,
                        isLink: false
                    });
                    return;
                } else {
                    if (record.item_name) {
                        this.items.push({
                            isLink: false,
                            label: record.item_name
                        });
                    }
                }
                break;

            default:
                if (record.item && Object.keys(record.item).length > 0) {
                    if (record.item.encoded_id) {
                        this.items.push({
                            label: record.item.name,
                            isLink: true,
                            encodedId: record.item.encoded_id
                        });
                    } else {
                        this.items.push({
                            isLink: false,
                            label: record.item.name
                        });
                    }
                    return;
                } else {
                    if (record.item_name) {
                        this.items.push({
                            isLink: false,
                            label: record.item_name
                        });
                    }
                }
                break;
        }
    }
};
</script>
